// all images inside the image modal content class
const lightboxImages = document.querySelectorAll('#modal');

const modalElement = element =>
  document.querySelector(`.image-modal-popup ${element}`);

const body = document.body;

const modalPopup = document.querySelector('.image-modal-popup');

document.addEventListener('click', () => {
  body.style.overflow = 'auto';

  if (modalPopup) {
    modalPopup.style.display = 'none';
  }
});

lightboxImages.forEach(img => {
  const data = img.dataset;

  img.addEventListener('click', e => {
    body.style.overflow = 'hidden';
    e.stopPropagation();

    if (!modalPopup) return;

    modalPopup.style.display = 'block';
    modalElement('img').src = img.src;
    modalElement('p').innerHTML = data.description;

    if (modalElement('p').innerHTML == "undefined") {
      modalElement('p').style.display = 'none';
    }
  });
});